//
//
//
//
//
//
//
//
//

import FastClick from 'fastclick'
export default {
  name: 'App',
  created () {
    window.addEventListener('offline', () => {
      this.$vux.toast.text('网络已断开连接', 'middle')
    }, false)

    window.addEventListener('online', () => {
      window.location.reload()
    }, false)

    FastClick.attach(document.body)
  }
}



// WEBPACK FOOTER //
// ./src/App.vue